import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { AlertMessageComponent, AlertModule as CosoAlertModule } from "@coso/alert";
import { ConnectionFormsModule } from "@coso/connection-forms";
import { FormsModule as CosoFormsModule } from "@coso/forms";
import { GridModule } from "@coso/grid";
import { LoggerModule } from "@coso/logger";
import { UtilityModule } from "@coso/utility";
import { AlertModule } from "ngx-bootstrap/alert";
import { ButtonsModule } from "ngx-bootstrap/buttons";
import { PopoverModule } from "ngx-bootstrap/popover";
import { TooltipModule } from "ngx-bootstrap/tooltip";
import { PageHeaderModule } from "../../../page-header/page-header.module";
import { AddEditSharePointComponent } from "./add-edit-sharepoint/add-edit-sharepoint.component";
import { AddEditExplicitFolderPermissionComponent } from "./explicit-folder-permissions/add-edit-explicit-folder-permission/add-edit-explicit-folder-permission.component";
import { ExplicitFolderPermissionsComponent } from "./explicit-folder-permissions/explicit-folder-permissions.component";
import { AddEditPermissionMappingComponent } from "./permission-mapping/add-edit-permission-mapping/add-edit-permission-mapping.component";
import { PermissionMappingSettingsComponent } from "./permission-mapping/permission-mapping-settings/permission-mapping-settings.component";
import { PermissionMappingComponent } from "./permission-mapping/permission-mapping.component";
import { SharePointRoutingModule } from "./sharepoint-routing.module";
import { CustomUserMappingComponent } from "./user-mapping/custom-user-mapping/custom-user-mapping.component";
import { UserMappingSettingsComponent } from "./user-mapping/user-mapping-settings/user-mapping-settings.component";
import { UserMappingComponent } from "./user-mapping/user-mapping.component";
import {GroupsComponent} from "./groups/groups.component";
import {AddGroupComponent} from "./groups/add-group/add-group.component";

@NgModule({
  declarations: [
    AddEditSharePointComponent,
    PermissionMappingComponent,
    UserMappingComponent,
    ExplicitFolderPermissionsComponent,
GroupsComponent,
    AddGroupComponent,
    CustomUserMappingComponent,
    AddEditExplicitFolderPermissionComponent,
    PermissionMappingSettingsComponent,
    AddEditPermissionMappingComponent,
    UserMappingSettingsComponent
  ],
  imports: [
    AlertMessageComponent,
    CommonModule,
    SharePointRoutingModule,
    AlertModule,
    CosoAlertModule,
    PageHeaderModule,
    ReactiveFormsModule,
    CosoFormsModule,
    ConnectionFormsModule,
    UtilityModule,
    TooltipModule,
    FormsModule,
    LoggerModule,
    PopoverModule,
    GridModule,
    ButtonsModule
  ]
})
export class SharePointModule {}
